import projet from './projet';
import projetsuivi from './projetsuivi';
import pages from './pages';
import admin from './admin';

const menuItems = {
  items: [projet, projetsuivi, pages, admin]
};

export default menuItems;
